export default __webpack_public_path__ + "static/media/pin.3c1d47d8.svg";